import { domains, type environmentNames } from 'ui/config/constants';
import { getConfigString } from 'ui/util/getConfigString';
import type { RuntimeConfig } from 'nuxt/schema';

export interface ENVValues {
  app_env: environmentNames,
  api_token: string,
}

export const getConfig = (allEnv: RuntimeConfig) => {
  const appEnv = getConfigString('app_env', allEnv) as environmentNames;
  const config = {
    env: appEnv,
    isLocal: appEnv === 'local',
    domains: domains[appEnv],
    apiToken: getConfigString('api_token', allEnv),
  };
  return config;
};
